import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function GridWithStepsSingleTitleHieght( container ) {

			var steps = container.querySelectorAll('.gridWithStepsSingle');
			var columns = 3;
			var titleHeightCurrent;
			var titleHeightTemp = 0;
			var n = 1;

			function columnCount() {

				if( window.outerWidth > 1024 ) {

					columns = 3;

				} else if( window.outerWidth > 748 ) {

					columns = 2 ;

				} else {

					columns = 1;

				}

			}

			function titleHeight() {

				steps.forEach( function( single, index ){

					single.querySelector('.gridWithStepsSingle__title').style.height = 'auto';
					titleHeightCurrent = single.querySelector('.gridWithStepsSingle__title').offsetHeight;

					if( titleHeightCurrent > titleHeightTemp ) {

						titleHeightTemp = titleHeightCurrent;

					}

					if( index+1 == (columns*n) ) {

						for (var i = columns; i > 0; i--) {

							steps.forEach( function( single2, index2 ){

								if( index2 == index + 1 - i ) {

									single2.querySelector('.gridWithStepsSingle__title').style.height = titleHeightTemp+'px';

								}

							});

						}

						n += 1;

						titleHeightTemp = 0;
					}

				});

			}

			function init() {

				columnCount();
				titleHeight();

			}

			window.addEventListener('resize', function(){

				n = 1;
				titleHeightTemp = 0;
				init();
 				
			});

			init();

		}

		function GridWithStepsScrollToForm( container ) {	

			var form = document.querySelector('form');

			if( form ) {

				var button = container.querySelector('.scrollToForm');

				var formSection;
				var formSectionCoordinate;
				var formSectionMarginTop;
				var topMove;

				function getTopPosition( formContainer ) {

					formSection = formContainer.closest('section');
					formSectionMarginTop = parseInt( getComputedStyle(formSection).marginTop.replace('px','') );

					formSectionCoordinate = formSection.getBoundingClientRect().top + window.pageYOffset - formSectionMarginTop;

					topMove = formSectionCoordinate - document.querySelector('header').offsetHeight;

				}

				getTopPosition( form );				

				button.addEventListener('click', function() {

					window.scrollTo({
					    top: topMove,
					    behavior: 'smooth'
					});

				});

				window.addEventListener('resize', function(){ 

					getTopPosition( form );

				});
				
			} else {

				container.querySelector('.gridWithSteps__findOut').classList.add('disable');

			}

		}

		function GridWithStepsScrollMagic( container ) {

			var grid = container.querySelector('.gridWithSteps__grid');

			var controller = new ScrollMagic.Controller();

			new ScrollMagic.Scene({triggerElement: grid, triggerHook: 0.95 })
				// trigger animation by adding a css class
				.setClassToggle(grid, "backToPosition")
				// .addIndicators({name: "- GridWithSteps "}) // add indicators (requires plugin)
				.addTo(controller)
				.offset(1);

		}

		function FindOutScrollMagic( container ) {

			var findOut = container.querySelector('.gridWithSteps__findOut');

			if( findOut && !findOut.classList.contains('disable') ) {

				var controller = new ScrollMagic.Controller();

				new ScrollMagic.Scene({triggerElement: findOut, triggerHook: 0.8 })
					// trigger animation by adding a css class
					.setClassToggle(findOut, "backToPosition")
					// .addIndicators({name: "- GridWithSteps Findout "}) // add indicators (requires plugin)
					.addTo(controller)
					.offset(1);

			}

		}

		var container = document.querySelectorAll('.gridWithSteps');

		if( container.length >0 ) {

			container.forEach( function( box, index ) {

				GridWithStepsSingleTitleHieght( box );
				GridWithStepsScrollToForm( box );
				GridWithStepsScrollMagic( box );
				FindOutScrollMagic( box );

			});

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
